export default __webpack_public_path__ + "static/media/Boots of Insanity.d17aec6e.jpg";